import { Observable } from 'rxjs'
import intl from 'react-intl-universal'
import { errorAction } from '~/redux/commonActions'
export const ACTION_DELETE_STORY = 'ellipsis.actions.deleteStory'

export default (action$, store, { serviceResolver, showSuccess, closeTab }) =>
  action$
    .ofType(ACTION_DELETE_STORY)
    .mergeMap((action) => {
      const storyService = serviceResolver('storyService')
      return Observable.from(storyService.delete())
        .map((response) => {
          if (!response.data.deleted) {
            throw Error(intl.get('epics.deleteStoryEpic.failure'))
          } else {
            showSuccess(intl.get('epics.deleteStoryEpic.success'))
          }
          return response
        })
        .delay(3000)
        .map(closeTab)
        .catch((errOrWhatever) => {
          if (errOrWhatever instanceof Error) {
            return Observable.of(errorAction(errOrWhatever))
          } else {
            return Observable.of(
              errorAction(Error(intl.get('epics.deleteStoryEpic.failure')))
            )
          }
        })
    })
    .filter((action) => !!action)
